import { render, staticRenderFns } from "./Printers.vue?vue&type=template&id=61931b7a&scoped=true"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"
import style0 from "./Printers.vue?vue&type=style&index=0&id=61931b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61931b7a",
  null
  
)

export default component.exports